import React, { useState } from 'react';
import { useQuery } from 'react-query';
import Loading from '../../pages/Loading/Loading';

const Notification = () => {
    const [ showNotificationDetails, setShowNotificationDetails] = useState({})
    const { data, isLoading, refetch } = useQuery("notificationz", () => fetch(`${process.env.REACT_APP_SECRET_API}/user/notification`, {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()
    )
    )

    if (isLoading) {
        return <Loading></Loading>
    }

    const showNotificationModel = async (id) => {

        await fetch(`${process.env.REACT_APP_SECRET_API}/user/notification/${id}`, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                'content-type': "application/json",
                'authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => res.json())
            .then(data => {
                // console.log(data)
                setShowNotificationDetails(data)
            })
            refetch()
    }

    const notification = data?.data;
    

    return (
        <div className='container py-20'>
            {notification?.map(item => (
                // {item?.mark_as_read ===0 ? "" : ""}
                <div key={item?.id} className={`alert flex-row shadow ${item?.mark_as_read === 0 ? "bg-white" : ""} my-3 rounded-none`}>
                    {item?.mark_as_read === 0 ?
                        (
                            <div className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                <div>
                                    <h3 className="font-bold">New message!</h3>
                                    <div className="text-xs">{item?.message}</div>
                                </div>
                            </div>
                        ) : (
                            <div className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                <div>
                                    <h3 className="font-bold">Already Open</h3>
                                    <div className="text-xs">{item?.message}</div>
                                </div>
                            </div>
                        )}

                    <div className="flex-none">
                        {/* <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button> */}
                        <label htmlFor="details_notification_modal" onClick={() => showNotificationModel(item?.id)} className="btn btn-xs" style={{ borderRadius: "5px" }}>See</label>
                    </div>
                </div>
            ))}
            
            {/* <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <div>
                        <h3 className="font-bold">Already Open</h3>
                        <div className="text-xs">Your order success delivery</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <div>
                        <h3 className="font-bold">Already Open</h3>
                        <div className="text-xs">Your order success delivery</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <div>
                        <h3 className="font-bold">Already Open</h3>
                        <div className="text-xs">Your order success delivery</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <div>
                        <h3 className="font-bold">Already Open</h3>
                        <div className="text-xs">Your order success delivery</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div>
            <div className="alert flex-row shadow my-3 rounded-none">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info flex-shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <div>
                        <h3 className="font-bold">New message!</h3>
                        <div className="text-xs">You have 1 unread message</div>
                    </div>
                </div>
                <div className="flex-none">
                    <button className="btn btn-xs" style={{ borderRadius: "5px" }}>See</button>
                </div>
            </div> */}
            <input type="checkbox" id="details_notification_modal" className="modal-toggle" />
            <label htmlFor="details_notification_modal" className="modal cursor-pointer">

                <div className="flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow md:flex-row md:max-w-xl hover:bg-gray-100 ">
                    <div className="flex flex-col justify-between p-4 leading-normal">
                        <p className="mb-3 font-normal text-black">{showNotificationDetails?.data?.message}</p>
                    </div>
                </div>
            </label>
        </div>
    );
};

export default Notification;